// shipping-countdown.js
document.addEventListener('DOMContentLoaded', function() {
  var cutoffHour = 16; // 16:00 = 4 PM same‑day shipping cutoff
  var display = document.getElementById('shipping-countdown');
  if (!display) return;

  function update() {
    var now = new Date();
    var cutoff = new Date(now.getFullYear(), now.getMonth(), now.getDate(), cutoffHour);
    if (now > cutoff) {
      // if past cutoff, you could set next‑day shipping or just show 00:00:00:
      cutoff.setDate(cutoff.getDate() + 1);
    }
    var diff = cutoff - now;
    if (diff < 0) diff = 0;
    var hrs = Math.floor(diff / 36e5);
    var mins = Math.floor((diff % 36e5) / 6e4);
    var secs = Math.floor((diff % 6e4) / 1000);
    function pad(n){ return n < 10 ? '0'+n : n }
    display.textContent = pad(hrs) + ':' + pad(mins) + ':' + pad(secs);
  }

  update();
  setInterval(update, 1000);
});
